import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-4d45cf8f"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["src"];
import { ref } from "vue";
// Reactive variable to hold the header color
export default /*#__PURE__*/ _defineComponent({
    __name: 'HeaderLayout',
    setup(__props) {
        const headerColor = ref("#000"); // Default background color
        // No need to export default as the script setup is already defining the component
        const getLogoUrl = () => {
            const domain = window.location.hostname;
            switch (domain) {
                case "automotive-roadassistancewebapp-staging.ispgnet.com":
                    return "/logo.svg";
                case "almulla-roadassistancewebapp-develop.ispgnet.com":
                    headerColor.value = "#EDEEEF"; // Green background for this domain
                    return "/almulla-logo.svg";
                case "almulla-roadassistancewebapp-preprod.ispgnet.com":
                    headerColor.value = "#EDEEEF"; // Green background for this domain
                    return "/almulla-logo.svg";
                case "stellantis-roadassistancewebapp-common-develop.ispgnet.com":
                    headerColor.value = "#EDEEEF";
                    return "/stellantis-logo.png";
                case "aljazirah-roadassistancewebapp-common-develop.ispgnet.com":
                    headerColor.value = "#EDEEEF";
                    return "/aljazirah-logo.png";
                case "localhost":
                    headerColor.value = "#EDEEEF"; // Green background for this domain
                    return "/almulla-logo.svg";
                default:
                    return "/logo.svg";
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("header", {
                style: _normalizeStyle({ backgroundColor: headerColor.value })
            }, [
                _createElementVNode("img", {
                    src: getLogoUrl(),
                    alt: "",
                    style: { "max-width": "200px" }
                }, null, 8, _hoisted_1)
            ], 4));
        };
    }
});
